import React from 'react';
import { Link } from 'react-router-dom';

const AgentsDashboard = () => {
  return (
    <div className="max-w-md mx-auto mt-10">
      <h1 className="text-2xl font-bold mb-6">Agents Dashboard</h1>
      <div className="space-y-4">
        <Link to="/gpt/new" className="block w-full py-4 px-6 border-2 border-gray-300 rounded-md bg-transparent text-center text-white text-bold hover:text-black hover:bg-blue-50 transition duration-300">
          Chatear
        </Link>
        <Link to="/agentes/crear" className="block w-full py-4 px-6 border-2 border-gray-300 rounded-md bg-transparent text-center text-white text-bold hover:text-black hover:bg-blue-50 transition duration-300">
          Crear Agente
        </Link>
        <Link to="/agentes/documentos" className="block w-full py-4 px-6 border-2 border-gray-300 rounded-md bg-transparent text-center text-white text-bold hover:text-black hover:bg-blue-50 transition duration-300">
          Documentos
        </Link>
        <Link to="/agentes/bdd" className="block w-full py-4 px-6 border-2 border-gray-300 rounded-md bg-transparent text-center text-white text-bold hover:text-black hover:bg-blue-50 transition duration-300">
          Bases de Datos
        </Link>
      </div>
    </div>
  );
};

export default AgentsDashboard;
